const ALARMCLOCK_ICON = 'fa-sharp fa-regular fa-alarm-clock'
const ALIGNLEFT_ICON = 'fa-sharp fa-solid fa-align-left'
const ALIGNCENTER_ICON = 'fa-sharp fa-solid fa-align-center'
const ALIGNRIGHT_ICON = 'fa-sharp fa-solid fa-align-right'
const ARROWROTATELEFT_ICON = 'fa-sharp fa-regular fa-arrow-rotate-left'
const ARROWROTATERIGHT_ICON = 'fa-sharp fa-regular fa-arrow-rotate-right'
const ARROWSROTATE_ICON = 'fa-sharp fa-regular fa-arrows-rotate'
const ANGLEDOWN_ICON = 'fa-sharp fa-solid fa-angle-down'
const ANGLEDOWN_REGULAR_ICON = 'fa-sharp fa-regular fa-angle-down'
const ANGLEUP_ICON = 'fa-sharp fa-solid fa-angle-up'
const ANGLEUP_REGULAR_ICON = 'fa-sharp fa-regular fa-angle-up'
const ANGLELEFT_LIGHT_ICON = 'fa-sharp fa-light fa-angle-left'
const ANGLERIGHT_ICON = 'fa-sharp fa-solid fa-angle-right'
const ANGLERIGHT_LIGHT_ICON = 'fa-sharp fa-light fa-angle-right'
const ANGLESLEFT_ICON = 'fa-sharp fa-solid fa-angles-left'
const ANGLESRIGHT_ICON = 'fa-sharp fa-solid fa-angles-right'
const ARROWDOWN_ICON = 'fa-sharp fa-solid fa-arrow-down'
const ARROWUP_ICON = 'fa-sharp fa-solid fa-arrow-up'
const ARROWLEFT_ICON = 'fa-sharp fa-solid fa-arrow-left'
const ARROWRIGHT_ICON = 'fa-sharp fa-solid fa-arrow-right'
const ARROWRIGHTLEFT_ICON = 'fa-sharp fa-solid fa-arrow-right-arrow-left'
const ARROWRIGHTB_ICON = 'fa-sharp fa-regular fa-arrow-right-to-bracket'
const ARROWRIGHTFB_ICON = 'fa-sharp fa-regular fa-arrow-right-from-bracket'
const ARROWRIGHTUPFS_ICON = 'fa-sharp fa-regular fa-arrow-up-right-from-square'
const BARS_ICON = 'fa-sharp fa-regular fa-bars'
const BELL_LIGHT_ICON = 'fa-sharp fa-light fa-bell'
const BROWSER_LIGHT_ICON = 'fa-sharp fa-light fa-browser'
const BLOCK_LIGHT_ICON = 'fa-sharp fa-light fa-block'
const BLOG_ICON = 'fa-sharp fa-regular fa-blog'
const BLOG_LIGHT_ICON = 'fa-sharp fa-light fa-blog'
const BUILDINGS_LIGHT_ICON = 'fa-sharp fa-light fa-buildings'
const CHARTMIXED_ICON = 'fa-sharp fa-solid fa-chart-mixed'
const CHECK_ICON = 'fa-sharp fa-regular fa-check'
const CLONE_ICON = 'fa-sharp fa-regular fa-clone'
const CODE_ICON = 'fa-sharp fa-solid fa-code'
const CREDITCARD_LIGHT_ICON = 'fa-sharp fa-light fa-credit-card'
const DATABASE_ICON = 'fa-sharp fa-solid fa-database'
const DELETE_ICON = 'fa-sharp fa-regular fa-trash-can'
const ARCHIVE_ICON = 'fa-sharp fa-regular fa-box-archive'
const UNDO_ICON = 'fa-sharp fa-regular fa-undo'
const DISPLAY_ICON = 'fa-sharp fa-regular fa-display'
const DOLLAR_DUOTONE_ICON = 'fa-duotone fa-circle-dollar'
const DOWNLOAD_ICON = 'fa-sharp fa-solid fa-download'
const EDIT_ICON = 'fa-sharp fa-regular fa-pen-to-square'
const ENVELOPE_LIGHT_ICON = 'fa-sharp fa-light fa-envelope'
const EXPAND_LIGHT_ICON = 'fa-sharp fa-light fa-expand'
const EYE_ICON = 'fa-sharp fa-regular fa-eye'
const EYESLASH_ICON = 'fa-sharp fa-regular fa-eye-slash'
const FILE_ICON = 'fa-sharp fa-regular fa-file'
const FILEIMPORT_ICON = 'fa-sharp fa-solid fa-file-import'
const FLOPPY_ICON = 'fa-sharp fa-solid fa-floppy-disk'
const FLOPPYCIRCLE_ICON = 'fa-sharp fa-solid fa-floppy-disk-circle-arrow-right'
const GEAR_ICON = 'fa-sharp fa-regular fa-gear'
const GEAR_LIGHT_ICON = 'fa-sharp fa-light fa-gear'
const GEARS_ICON = 'fa-sharp fa-regular fa-gears'
const GRID_ICON = 'fa-sharp fa-regular fa-grid'
const GLOBE_ICON = 'fa-sharp fa-solid fa-globe'
const GLOBE_LIGHT_ICON = 'fa-sharp fa-light fa-globe'
const HOUSE_ICON = 'fa-sharp fa-solid fa-house'
const HOUSE_REGULAR_ICON = 'fa-sharp fa-regular fa-house'
const IMAGES_ICON = 'fa-sharp fa-regular fa-images'
const INDENT_ICON = 'fa-sharp fa-solid fa-indent'
const LISTTREE_ICON = 'fa-sharp fa-regular fa-list-tree'
const LOCK_ICON = 'fa-sharp fa-solid fa-lock'
const LOCK_LIGHT_ICON = 'fa-sharp fa-light fa-lock'
const MAGNIFYING_ICON = 'fa-sharp fa-solid fa-magnifying-glass'
const MOBILE_ICON = 'fa-sharp fa-regular fa-mobile-screen'
const OBJECTCOLUMNS_ICON = 'fa-sharp fa-solid fa-objects-column'
const OUTDENT_ICON = 'fa-sharp fa-solid fa-outdent'
const PIVOTTABLE_LIGHT_ICON = 'fa-sharp fa-light fa-table-pivot'
const PEOPLEROOF_LIGHT_ICON = 'fa-sharp fa-light fa-people-roof'
const PLUS_ICON = 'fa-sharp fa-solid fa-plus'
const PUZZLE_LIGHT_ICON = 'fa-sharp fa-light fa-puzzle'
const SERVER_ICON = 'fa-sharp fa-solid fa-server'
const SHAREFS_ICON = 'fa-sharp fa-regular fa-share-from-square'
const TABLE_ICON = 'fa-sharp fa-regular fa-table'
const TABLECOLUMNS_ICON = 'fa-sharp fa-regular fa-table-columns'
const UPDOWNLEFTRIGHT_ICON = 'fa-sharp fa-solid fa-up-down-left-right'
const UPLOAD_ICON = 'fa-sharp fa-solid fa-upload'
const USER_ICON = 'fa-sharp fa-regular fa-user'
const USERPLUS_ICON = 'fa-sharp fa-regular fa-user-plus'
const USERPLUS_LIGHT_ICON = 'fa-sharp fa-light fa-user-plus'
const USERMAGNIFYING_ICON = 'fa-sharp fa-regular fa-user-magnifying-glass'
const USERMMINUS_ICON = 'fa-sharp fa-regular fa-user-minus'
const VIDEO_LIGHT_ICON = 'fa-sharp fa-light fa-video'
const WAVEPULSE_LIGHT_ICON = 'fa-sharp fa-light fa-wave-pulse'
const XMARK_ICON = 'fa-sharp fa-regular fa-xmark'
const ELLIPSIS_ICON = 'fa fa-ellipsis-v'
const MAGIC_ICON = 'fa-regular fa-sparkles'

export {
  ALARMCLOCK_ICON,
  ALIGNLEFT_ICON,
  ALIGNCENTER_ICON,
  ALIGNRIGHT_ICON,
  ARROWROTATELEFT_ICON,
  ARROWROTATERIGHT_ICON,
  ARROWSROTATE_ICON,
  ANGLEDOWN_ICON,
  ANGLEDOWN_REGULAR_ICON,
  ANGLEUP_ICON,
  ANGLEUP_REGULAR_ICON,
  ANGLELEFT_LIGHT_ICON,
  ANGLERIGHT_ICON,
  ANGLERIGHT_LIGHT_ICON,
  ANGLESLEFT_ICON,
  ANGLESRIGHT_ICON,
  ARROWDOWN_ICON,
  ARROWUP_ICON,
  ARROWLEFT_ICON,
  ARROWRIGHT_ICON,
  ARROWRIGHTLEFT_ICON,
  ARROWRIGHTB_ICON,
  ARROWRIGHTFB_ICON,
  ARROWRIGHTUPFS_ICON,
  BARS_ICON,
  BELL_LIGHT_ICON,
  BROWSER_LIGHT_ICON,
  BLOCK_LIGHT_ICON,
  BLOG_ICON,
  BLOG_LIGHT_ICON,
  BUILDINGS_LIGHT_ICON,
  CHARTMIXED_ICON,
  CHECK_ICON,
  CLONE_ICON,
  CODE_ICON,
  CREDITCARD_LIGHT_ICON,
  DATABASE_ICON,
  DELETE_ICON,
  ARCHIVE_ICON,
  UNDO_ICON,
  DISPLAY_ICON,
  DOLLAR_DUOTONE_ICON,
  DOWNLOAD_ICON,
  EDIT_ICON,
  ENVELOPE_LIGHT_ICON,
  EXPAND_LIGHT_ICON,
  EYE_ICON,
  EYESLASH_ICON,
  FILE_ICON,
  FILEIMPORT_ICON,
  FLOPPY_ICON,
  FLOPPYCIRCLE_ICON,
  GEAR_ICON,
  GEAR_LIGHT_ICON,
  GEARS_ICON,
  GRID_ICON,
  GLOBE_ICON,
  GLOBE_LIGHT_ICON,
  HOUSE_ICON,
  HOUSE_REGULAR_ICON,
  IMAGES_ICON,
  INDENT_ICON,
  LISTTREE_ICON,
  LOCK_ICON,
  LOCK_LIGHT_ICON,
  MAGNIFYING_ICON,
  MOBILE_ICON,
  OBJECTCOLUMNS_ICON,
  OUTDENT_ICON,
  PIVOTTABLE_LIGHT_ICON,
  PEOPLEROOF_LIGHT_ICON,
  PLUS_ICON,
  PUZZLE_LIGHT_ICON,
  SERVER_ICON,
  SHAREFS_ICON,
  TABLE_ICON,
  TABLECOLUMNS_ICON,
  UPDOWNLEFTRIGHT_ICON,
  UPLOAD_ICON,
  USER_ICON,
  USERPLUS_ICON,
  USERPLUS_LIGHT_ICON,
  USERMAGNIFYING_ICON,
  USERMMINUS_ICON,
  VIDEO_LIGHT_ICON,
  WAVEPULSE_LIGHT_ICON,
  XMARK_ICON,
  ELLIPSIS_ICON,
  MAGIC_ICON,
}